export default "__VITE_ASSET__10Po5SRw__"